type TArgs = (PropertyKey | object)[];

export function emptyFn() {
}

let isDebug = false;

export function isDebugMode() {
    return isDebug;
}

export function setDebugMode(debugMode: boolean) {
    isDebug = debugMode;
}

export function log(...args: TArgs) {
    if (isDebug) {
        const _args = ['[native banner]', ...args];
        // eslint-disable-next-line no-console
        console.log(..._args);
    }
}

export function createLog(name: string): (...args: TArgs) => void {
    return isDebug
        ? (...args) => {
            const _args = [`[native banner / ${name}]`, ...args];
            // eslint-disable-next-line no-console
            console.log(..._args);
        }
        : emptyFn;
}

export function parseJson<D>(data: string): D | null {
    if (data) {
        const json = data.replace(/<!--/ig, '').replace(/-->/ig, '');
        return JSON.parse(json);
    }
    return null;
}

let getCurrentStateValue = () => 'unknown';

export function setCurrentStateGetter(currentStateGetter: typeof getCurrentStateValue) {
    getCurrentStateValue = currentStateGetter;
}

export function getCurrentState() {
    return getCurrentStateValue();
}

let getTopPanelHeight = () => 0;

export function setTopPanelHeightGetter(topPanelHeightGetter: typeof getTopPanelHeight) {
    getTopPanelHeight = topPanelHeightGetter;
}

export function getEffectiveViewportHeight() {
    return window.innerHeight - getTopPanelHeight();
}

let getCompactFooterHeightValue = () => 0;

export function setCompactFooterHeightGetter(compactFooterHeightGetter: typeof getCompactFooterHeightValue) {
    getCompactFooterHeightValue = compactFooterHeightGetter;
}

export function getCompactFooterHeight() {
    return getCompactFooterHeightValue();
}

export function isDarkThemeSelectedInBrowser() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
}

let isDarkThemeSelectedValue = isDarkThemeSelectedInBrowser;

export function setDarkThemeSelectedGetter(darkThemeSelectedGetter: typeof isDarkThemeSelectedValue) {
    isDarkThemeSelectedValue = darkThemeSelectedGetter;
}

export function isDarkThemeSelected() {
    return isDarkThemeSelectedValue();
}
